import api from "app/lib/api";
import endpoints from "static/endpoints";

export const physicianList = async (isPhysicianModal, queryParams = {}) => {
  if (!isPhysicianModal) return [];

  const params = new URLSearchParams();
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });
  const queryString = params.toString();
  const url = queryString
    ? `${endpoints.physicians.list}?${queryString}`
    : endpoints.physicians.list;

  const { physicians } = await api.get(url);
  return physicians;
};

export const updatePhysicianData = async (physicians, patientSerialNumber) => {
  const data = await api.put(endpoints.physicians.update, {
    patient: patientSerialNumber,
    information: {
      physicians,
    },
  });

  return data;
};
